import { useMemo } from "react";

import SBEditable from "../../../components/sbEditable/sbEditable";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import StoryblokLink from "../../../components/link/StoryblokLink";
import RouterLink from "../../../components/link/RouterLink";
import { buildInternalPath } from "../../../helpers/URLHelpers";

import { useCategoryArticles } from "../../../hooks/useStoryblokArticles";

import "./articleListingLayouts.scss";
import styles from "./articleListingPanel.module.scss";
import { useTagArticles } from "../../../hooks/useTagArticles";

const PER_PAGE = 6;

function ThreeColumnLSMListingPanel({ blok }) {
  const category = blok.type?.content?.title || blok.category?.content?.title;
  const tag = blok.tag.article_tag;

  const linkRel = blok.button_link?.rel

  const [allArticles, , isLoading] = tag
    ? useTagArticles(tag, PER_PAGE)
    : useCategoryArticles(category, PER_PAGE);

  var layout = "col3-lsm";
  if (blok.layout) {
    layout = blok.layout;
  }

  var chunkedData = useMemo(()=>{
    let chunked = [];

    var colCount = layout.match(/\d/gm)[0];
    var totalCount = allArticles.length;
    var chunkSize = totalCount / colCount;

    for (let i = 0; i < allArticles.length; i += chunkSize) {
      const chunk = allArticles.slice(i, i + chunkSize);
      chunked.push({ chunk });
    }

    return chunked
  },[allArticles]);

  if (!isLoading && allArticles.length === 0) {
    return null;
  }

  return (
    <div
      className={`${
        styles.articleListingWrapper
      } view with-padding page-content ${
        blok.margin_top ? styles.marginTopDefault : ""
      } ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}
      style={
        layout === "col2-ls" ? { maxWidth: "846px", marginLeft: "0" } : null
      }
    >
      <SBEditable blok={blok}>
        {blok.showHeader && blok.headline !== "" && blok.headline !== null ? (
          <ListingHeader>
            <div className={styles.listingHeaderChildren}>
              <h2>{blok.headline}</h2>
              {blok.show_button && (linkRel?.content.article_type || linkRel?.content.article_category) ? (
                  <RouterLink
                      to={buildInternalPath(linkRel?.slug)}
                      className={`${styles.button} ${styles.topButton} btn-scooter-outline`}
                  >
                    {blok.button_text}
                  </RouterLink>
              ) : null}
            </div>
          </ListingHeader>
        ) : null}
        {isLoading ? <div className="loader centered" /> : null}
        <div className={`${styles.articleListGrid} ${layout}`}>
          {chunkedData.map((chunk, idx) => {
            return (
              <div className={`${styles.col} col-${idx + 1}`}>
                {chunk["chunk"].map((a, jdx) => {
                  var layout = "featured";
                  let titleSize = "default";
                  var summary = a.content.lead;
                  var thumbnail = a.content.thumbnail;
                  if (idx === 0 && jdx === 1) {
                    layout = "inlinetopstories";
                    summary = null;
                    titleSize = "medium";
                  }
                  if (idx === 1) {
                    summary = null;
                    titleSize = "small";
                  }
                  if (idx === 2 && jdx === 1) {
                    layout = "noImage";
                    thumbnail = null;
                  }
                  return (
                    <div className={`${styles.articleCard} articleCard`}>
                      <ArticleListingCard
                        key={a.uuid}
                        titleSize={titleSize}
                        slug={a.slug}
                        thumbnail={thumbnail}
                        authors={a.content.authors}
                        title={a.content.headline}
                        summary={summary}
                        date={a.content.article_date}
                        article_category={a.content.category}
                        article_type={a.content.article_type}
                        comment_count={5}
                        enable_comments={a.content.has_comments}
                        enable_social_sharing={a.content.has_social_sharing}
                        use_legacy_thumbnail_background={
                          a.content.legacy_thumbnail_background
                        }
                        layout={layout}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
          {blok.show_button ? (
            <StoryblokLink
              linkObject={blok.button_link}
              className={`${styles.button} ${styles.bottomButton} btn-scooter-outline`}
            >
              {blok.button_text}
            </StoryblokLink>
          ) : null}
        </div>
      </SBEditable>
    </div>
  );
}

export default ThreeColumnLSMListingPanel;
